/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

export const storageNotSupported = "storage_not_supported";
export const stubbedPublicClientApplicationCalled =
    "stubbed_public_client_application_called";
export const inMemRedirectUnavailable = "in_mem_redirect_unavailable";
